import { getApi } from 'apis';

export const getAllCategories = async (params: any) => {
	return await getApi('/category', params);
};
 